import { TemplateResult, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import innerStyles from './styles/outline-footer.base.pcss?inline';
import globalStyles from './styles/outline-footer.global.pcss?inline';
import { AdoptedStyleSheets } from '../../controllers/adopted-stylesheets';
import '../outline-container/outline-container';
import '../outline-accent-bar/outline-accent-bar';
/**
 * The OutlineFooter component
 * @element outline-footer
 */
@customElement('outline-footer')
export class OutlineFooter extends LitElement {
  adoptedStyleSheets = new AdoptedStyleSheets(this, {
    globalCSS: globalStyles,
    encapsulatedCSS: innerStyles,
  });
  /**
   * Document property here
   */
  @property({ type: String, attribute: 'property-var' })
  propertyVar: string;

  render(): TemplateResult {
    return html`
    <footer class="outline-footer--wrapper">
      <outline-accent-bar></outline-accent-bar>
      <outline-container
        background-color="brand-boldest"
        content-max-width="default"
        y-padding="default"
      >
        <div class="outline-footer">
          <div class="outline-footer--main-content">
            <div class="outline-footer--nav">
              <slot name="logo"></slot>
              <slot name="footer-nav"></slot>
            </div>
            <div class="outline-footer--supplemental">
              <slot name="supplemental"></slot>
            </div>
          </div>
          <div class="outline-footer--bottom-content">
            <div class="outline-footer--legal">
              <slot name="copyright"></slot>
              <slot name="legal"></slot>
            </div>
            <div class="outline-footer--social">
              <slot name="social"></slot>
            </div>
          </div>
        </div>
      </outline-container>
    </footer>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'outline-footer': OutlineFooter;
  }
}
